import { MediaId } from "@mp-commons/model/MediaInfo.js";
import { VideoInfoRawData } from "@mp-commons/model/video/VideoInfo.js";
import { ExternallyPassedContentAdData } from "@mp-commons/modules/ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { GDPRSdk } from "@mp-commons/modules/ads/GDPR.js";
import { AdErrorStruct, PlayerAdEvent, PlayerAdEventType, isPlayerAdCompleteEvent, isPlayerAdPausedEvent, isPlayerAdResumedEvent, isPlayerAdStartedEvent } from "@mp-commons/modules/ads/PlayerAdEvent.js";
import { MediaControlOrigin, MediaEvent, MediaProgressEvent, isMediaCompleteEvent, isMediaLoadedEvent, isMediaPausedEvent, isMediaResumedEvent, isMediaStartedEvent } from "@mp-commons/modules/events/PlayerEvent.js";
import { ComScoreConfig, ComScoreStreamingTagFactory } from "@mp-commons/modules/stats/collectors/comscore/ComScoreStreamingTag.js";
import { ComScoreStreamingTagDynamic } from "@mp-commons/modules/stats/collectors/comscore/ComScoreStreamingTagDynamic.js";
import { PreFilteredEventMapper } from "@mp-commons/modules/stats/mappers/PreFilteredEventMapper.js";

export class MegarideCSStreamingTagMapper extends PreFilteredEventMapper<VideoInfoRawData> {


    private factory: ComScoreStreamingTagFactory;


    private activeItem: { [k: MediaId]: "ad" | "video" };


    constructor(private window: Window,
        comscoreCfg: ComScoreConfig,
        gdpr: Promise<GDPRSdk>,
        externalData?: ExternallyPassedContentAdData
    ) {
        super({
            media: true,
            adevents: [
                PlayerAdEventType.AD_STARTED,
                PlayerAdEventType.AD_COMPLETED,
                PlayerAdEventType.AD_RESUMED,
                PlayerAdEventType.AD_PAUSED
            ]
        });
        this.factory = new ComScoreStreamingTagDynamic(comscoreCfg, gdpr, externalData);
    }


    public preload(): Promise<void> {
        if (this.factory instanceof ComScoreStreamingTagDynamic) {
            return this.factory.preload().then();
        }
        else Promise.resolve();
    }


    protected onAdError(errorStruct: AdErrorStruct, adjustedLabel?: string, adjustedEventLabel?: string): void {
        //nothing to do
    }
    protected onAdEvent(evt: PlayerAdEvent, adjustedLabel?: string, adjustedEventLabel?: string): void {

        if (isPlayerAdStartedEvent(evt) && evt.adInfo.linear) {
            this.factory.getStreamingTag(evt).then(tag => {
                //tag.end();
                tag.adStarted(evt);
            });
        }
        else if (isPlayerAdCompleteEvent(evt)) {
            this.factory.getStreamingTag(evt).then(tag => {
                tag.adEnded();
            });
        }
        else if (isPlayerAdPausedEvent(evt)) {
            this.factory.getStreamingTag(evt).then(tag => {
                tag.adPaused();
            })
        }
        else if (isPlayerAdResumedEvent(evt)) {
            this.factory.getStreamingTag(evt).then(tag => {
                tag.adResumed();
            })
        }



    }
    protected onMediaProgress(progEvent: MediaProgressEvent, corrected_percentage: number): void {
        //nothing to do
    }

    protected onMediaEvent(evt: MediaEvent<VideoInfoRawData>): void {


        if (isMediaStartedEvent(evt)) {
            this.factory.getStreamingTag(evt).then(tag => tag.play(0));
        }
        else if (isMediaPausedEvent(evt) && evt.origin == MediaControlOrigin.USER) {
            this.factory.getStreamingTag(evt).then(tag => tag.pause());
        }
        else if (isMediaResumedEvent(evt)) {
            this.factory.getStreamingTag(evt).then(tag => tag.play(evt.currentTime));
        }
        else if (isMediaCompleteEvent(evt)) {
            this.factory.getStreamingTag(evt).then(tag => tag.end());
        }

        else if (isMediaLoadedEvent(evt)) {
            this.factory.getStreamingTag(evt);
        }



    }



} 